<template>
  <v-dialog v-model="dialog" max-width="700" transition="dialog-bottom-transition">
    <template v-if="!hideActivator" v-slot:activator="{ on, attrs }">
      <v-card v-bind="attrs" v-on="on" icon :class="cardClass" height="100px" width="100px" flat>
        <v-img
          class="white--text"
          height="100px"
          gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
          :src="src"
        >
          <v-card-text
            ><small>{{ title }}</small></v-card-text
          >
        </v-img>
      </v-card>
    </template>
    <v-row no-gutters>
      <v-card>
        <v-img width="100%" max-width="700" :src="src" @click="close">
          <v-card-title class="white--text">
            {{ title }}
            <v-spacer />
            <v-btn icon>
              <v-icon @click="close" color="white">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-img>
      </v-card>
    </v-row>
  </v-dialog>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ImageDialog extends DarkModeHighlightMixin {
  @Prop()
  src!: string;

  @Prop({ default: "mx-4 mb-4" })
  cardClass!: string;

  @Prop({ default: "" })
  title!: string;

  /**
   * Hides the image card that activates the dialog, for cases where the dialog is opened via `open()` instead.
   */
  @Prop({ default: false })
  hideActivator!: boolean;

  dialog = false;

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
</script>
